
import React, { useState, useEffect} from 'react'

import UseYearMonthDateShort from '../../hooks/UseYearMonthDateShort';

import classes from "./TimeDatePciker.module.css"

const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
};

const getCurrentDate = (label) => {
    const newDate = new Date();
    
    let startDate = UseYearMonthDateShort(newDate);
    const maxDate = UseYearMonthDateShort(newDate.setUTCFullYear(newDate.getUTCFullYear() + 1));

    return { startDate, minDate: startDate, maxDate };
}

const TimeDatePicker = ({ handler, label, preSelectedTime }) => {
        // Initialize state with current time
    const [time, setTime] = useState();
        
    const getCurrentDateString = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const [date, setDate] = useState(getCurrentDateString());
    const [minDate, setMinDate] = useState("");
    const [maxDate, setMaxDate] = useState("");

    const handleTimeChange = (event) => {
        const Time = event.target.value
        setTime(Time);
        if (Time != undefined || Time != null) {
            handler(Time, date);
        }
    };

    const handleDateChange = (event) => {
        const newDate = event.target.value;
        setDate(newDate);

        handler(time, { startDate: newDate, minDate, maxDate });
    };

    const [initialLoad, setInitialLoad] = useState(true);

    useEffect(() => {
        const Time = getCurrentTime();
        const { startDate, minDate, maxDate } = getCurrentDate();
        
        setTime(Time);
        ///setDate(startDate);
        setMinDate(minDate);
        setMaxDate(maxDate);

        if (initialLoad) {          
            handler(Time, { startDate, minDate, maxDate });
            setInitialLoad(false);
        }
    }, []);

    return (
        <div className={classes["container"]}>
            <label htmlFor="appt">{label || "Select Date and Time on:"}</label>
            <input
                type="time"
                id="timePicker"
                name="holiday-timePicker"
                value={time}
                onChange={handleTimeChange}
                className={classes["time-input"]}
            />
            <label htmlFor="appt">{"on the"}</label>
          <input
            type="date"
            id="start"
            className={classes["time-input"]}
            name="holiday-start"
            value={date}
            min={minDate}
            max={maxDate}
            onChange={handleDateChange}
        />
        </div>
    )
}

export default TimeDatePicker